const initialState = {
    catalog:[],
    pallets: [],
    bienes: '',
    plan: 6,
    pickupAddress: '',
    pickupAddressInternal: '',
    pickupCoordinates: '',
    floor: 'PB',
    extra_floor_price: 0,
    freight_price: 0,
    heavy: false,
    heavy_specs: 0,
    heavy_price: 0,
    heavy_loaders: 0,
    fly: false,
    fly_price: 0,
    fly_specs: 0,
    disarm: false,
    disarm_price: 0,
    disarm_specs: 0,
    emplayado: false,
    emplayado_price: 0,
    long_distance: false,
    long_distance_price: 0,
    special_requirements: '',
    mts2: 0,
    total_price: 0,
    mts2_price: 0,
    loaders: 0,
    property_type: 'house',
    how_download: '',
    pickup_price: 0,
    regular_pickup_price: 0,
    delivery_price: 0,
    regular_delivery_price: 0,
    user_id: 0,
    needFreight: true,
    coupon: null,
    coupon_amount: null,
    coupon_type: null,
    user: {
      name: '',
      email: '',
      phone_number: ''
    }
}
  
const cotizador = (state = initialState, action) => {
    switch (action.type) {

        case 'UPDATE_COTIZADOR_DATA':
          
          var newFormData = Object.assign({},state,action.payload)
          
          return Object.assign({}, state, newFormData)
        case 'REINIT_FORMDATA': {
          return Object.assign({}, state, {
            pallets: [],
            plan: 2,
            pickupAddress: '',
            pickupAddressInternal: '',
            pickupCoordinates: '',
            floor: '',
            extra_floor_price: 0,
            freight_price: 0,
            heavy: false,
            heavy_specs: 0,
            heavy_price: 0,
            heavy_loaders: 0,
            fly: false,
            fly_price: 0,
            fly_specs: 0,
            disarm: false,
            disarm_price: 0,
            disarm_specs: 0,
            emplayado: false,
            emplayado_price: 0,
            long_distance: false,
            long_distance_price: 0,
            special_requirements: '',
            mts2: 0,
            total_price: 0,
            mts2_price: 0,
            loaders: 0,
            property_type: 'house',
            how_download: '',
            pickup_price: 0,
            regular_pickup_price: 0,
            delivery_price: 0,
            regular_delivery_price: 0,
            user_id: 0,
            needFreight: true,
            coupon: false,
            coupon_amount: 0,
            coupon_type: '',
          })
        }
        default:
          return state
    }
}
    
    export default cotizador